import{View}from'./View';export class Map extends View{}